import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import DateInputField from "./DateInputField";
import "./DatePickerField.css";

class DatePickerField extends React.Component {
  handleDateChange = (date, fieldName, callback) => {
    callback(fieldName, date);
  };

  renderComponent = () => {
    const {
      name,
      action,
      value = moment(),
      readOnly = false,
      disabled = false,
      required,
      minDate = moment(0),
      startDate = moment(0),
      endDate = moment(),
      maxDate = moment(),
      popoverAttachment = "top right",
      popoverTargetAttachment = "bottom right",
      showYearDropdown = true,
      showMonthDropdown = true,
      showTimeSelect = false,
      showTimeSelectOnly = false,
      timeIntervals,
      timeCaption,
      dateFormat,
      minTime,
      maxTime,
      className
    } = this.props;
    return (
      <div>
        <DatePicker
          className={className}
          customInput={
            !showTimeSelect ? (
              <DateInputField
                onClick={this.props.onClick}
                onChange={(date) => this.handleDateChange(date, name, action)}
                className="inputcontainer"
              />
            ) : (
              ""
            )
          }
          selected={value}
          minDate={minDate}
          startDate={startDate}
          endDate={endDate}
          onChange={(date) => this.handleDateChange(date, name, action)}
          maxDate={maxDate}
          showYearDropdown={showYearDropdown}
          showMonthDropdown={showMonthDropdown}
          //scrollableYearDropdown
          //yearDropdownItemNumber={100}
          selectsStart
          disabledKeyboardNavigation
          popoverAttachment={popoverAttachment}
          popoverTargetAttachment={popoverTargetAttachment}
          readOnly={readOnly}
          disabled={disabled}
          required={required}
          showTimeSelect={showTimeSelect}
          showTimeSelectOnly={showTimeSelectOnly}
          timeIntervals={timeIntervals}
          timeCaption={timeCaption}
          dateFormat={dateFormat}
          minTime={minTime}
          maxTime={maxTime}
        />
      </div>
    );
  };

  render() {
    return this.renderComponent();
  }
}
export default DatePickerField;
